export default "__VITE_ASSET__D2hQe9TW__"